import http from "../http-common";

class RecurrenceService {
  getAll() {
    return http.get("/recurrences");
  }

  create(data) {
    return http.post("/recurrences", data);
  }
}

export default new RecurrenceService();
